import React from "react";
import classes from "./Teams.module.css";
import { Team } from "../../Components/index";
import teams from "../../assets/json/teams.json";

function Teams() {
  const teamList = teams.map((team) => {
    return (
      <Team
        key={team.id}
        name={team.name}
        position={team.position}
        link={team.linkedIn}
        src={team.img}
      />
    );
  });
  return (
    <section className={classes.Teams}>
      <h2 className={classes.TeamTitle}>
        Our <span>Team</span>
      </h2>
      <div className={classes.TeamList}>{teamList}</div>
    </section>
  );
}

export default Teams;
